var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-table-cell-document"},[_c('div',{staticClass:"ui-table-cell-document__icon"},[_c('icon',{attrs:{"name":"document"}})],1),_c('a',{staticClass:"ui-table-cell-document__title",attrs:{"href":_vm.href},domProps:{"textContent":_vm._s(_vm.title)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }